<template>
  <v-flex>
    <h1 class="display-1 primary--text">
      {{ $t('message.profile') }}
    </h1>
    <v-form
      novalidate
      @submit.prevent="validateUser"
    >
      <v-text-field
        v-model="user.email"
        name="login"
        :label="($t('message.email') + ' *')"
        type="text"
        disabled
        :hint="$t('message.cant_be_changed')"
        persistent-hint
        class="mb-5"
        :error-messages="validationErrors['email']"
      />
      <v-flex
        layout
        row
      >
        <v-text-field
          v-model="user.first_name"
          required
          name="first_name"
          :label="($t('message.first_name') + ' *')"
          type="text"
          :error-messages="validationErrors['first_name']"
        />
        <v-text-field
          v-model="user.insertion"
          name="insertion"
          :label="$t('message.insertion')"
          type="text"
          class="ml-5 mr-5 shrink"
        />
        <v-text-field
          v-model="user.last_name"
          required
          name="last_name"
          :label="($t('message.last_name') + ' *')"
          type="text"
          :error-messages="validationErrors['last_name']"
        />
      </v-flex>
      <v-radio-group
        v-model="user.sex"
        layout
        row
        :label="($t('message.sex') + ':')"
        :items="sexes"
      >
        <v-radio
          v-for="(item, index) in sexes"
          :key="index"
          :label="item.title"
          :value="item.id"
          class="ml-5"
        />
      </v-radio-group>
      <!-- <v-text-field
            v-model="user.birth_date"
            name="birth_date"
            :label="$t('message.birth_date')"
            mask="##/##/####"
            :hint="$t('message.birth_date_hint')"
            persistent-hint
          ></v-text-field> -->
      <v-text-field
        v-model="user.phone"
        name="phone"
        :label="$t('message.phone')"
        type="text"
      />
      <v-checkbox
        v-model="user.receive_newsletter"
        :label="$t('message.receive_newsletter')"
        hide-details
      />
      <v-btn
        color="secondary"
        type="submit"
      >
        {{ $t('message.save') }}
      </v-btn>
    </v-form>
    <v-snackbar
      v-model="showError"
      color="error"
      :multi-line="true"
    >
      {{ $t('message.general_form_error') }}
      <v-btn
        dark
        flat
        @click="showError = false"
      >
        {{ $t('message.close') }}
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="showServiceError"
      color="error"
      :multi-line="true"
    >
      {{ serviceError }}
      <v-btn
        dark
        flat
        @click="showError = false"
      >
        {{ $t('message.close') }}
      </v-btn>
    </v-snackbar>
  </v-flex>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
export default {
  mixins: [validationMixin],
  data: (vm) => ({
    sexes: [
      { id: 'f', title: vm.$t('message.sex_female') },
      { id: 'm', title: vm.$t('message.sex_male') },
      { id: '', title: vm.$t('message.sex_undefined') },
    ],
    privacyStatementLink: vm.$t('message.agree_with_privacy_statement'),
    agree_with_privacy_statement: false,
    registerError: '',
    serviceError: '',
    showError: false,
    showServiceError: false,
    menu: false,
  }),
  computed: {
    ...mapState({
      user: (state) => Object.assign({}, state.user),
    }),
    displayBirthDate() {
      return this.formatDate(this.user.birth_date)
    },
    validationErrors() {
      const v = this.$v.user
      function errorsFromArray(fieldName, validations) {
        return validations
          .filter((obj) => {
            return !v[fieldName][obj.key]
          })
          .map((o) => o.message)
      }

      const errors = {
        first_name: this.$t('message.required_field'),
        last_name: this.$t('message.required_field'),
        confirm_password: errorsFromArray('confirm_password', [
          { key: 'sameAs', message: this.$t('message.passwords_mismatch') },
        ]),
      }

      const newErrors = {}
      Object.keys(errors).forEach((fieldName) => {
        if (fieldName == 'agree_with_privacy_statement') {
          newErrors[fieldName] =
            this.$v.agree_with_privacy_statement.$dirty &&
            this.$v.agree_with_privacy_statement.$invalid
              ? errors[fieldName]
              : undefined
        } else {
          newErrors[fieldName] =
            this.$v.user[fieldName].$dirty && this.$v.user[fieldName].$invalid
              ? errors[fieldName]
              : undefined
        }
      })

      return newErrors
    },
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == 'registrationError') {
        this.serviceError = mutation.payload.message
        this.showServiceError = true
      }
    })
  },
  methods: {
    saveDate(date) {
      this.$refs.menu.save(date)
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return day !== undefined ? `${day}-${month}-${year}` : `${month}-${year}`
    },
    validateUser() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('updateUserProfile', this.user)
      } else {
        this.showError = true
      }
    },
  },
  validations: {
    user: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      confirm_password: {
        sameAsPassword: sameAs('password'),
      },
    },
    agree_with_privacy_statement: {
      required,
    },
  },
}
</script>
